import { useCallback, useEffect, useState } from 'react';
import { NostroGeneralContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCustomersAccountBalanceQuery } from '../store/services/customers';

const ProblemNostroGeneralContentHOC = (): React.JSX.Element => {
  const [fromAccountBalance, setFromAccountBalance] = useState<number>();
  const [toAccountBalance, setToAccountBalance] = useState<number>();

  const [getFromAccountBalance, { isLoading, isFetching }] =
    useLazyGetCustomersAccountBalanceQuery();
  const [
    getToAccountBalance,
    { isLoading: toBalanceIsLoading, isFetching: toBalanceIsFetching },
  ] = useLazyGetCustomersAccountBalanceQuery();

  const {
    customersProblemTransactions: {
      nostro: { transaction },
    },
    customersDictionaries: { currenciesList, paymentTypes },
  } = useAppSelector((state) => state);

  const getFromAccountBalanceAction = useCallback(async () => {
    const response = (await getFromAccountBalance({
      id: transaction?.senderAccount.id,
      currencyId: transaction?.currencyId as string,
    })) as { data: { data: { edges: { node: { value: number } }[] } } };

    if (response.data) {
      setFromAccountBalance(response.data.data.edges[0].node.value);
    }
  }, [transaction]);

  const getToAccountBalanceAction = useCallback(async () => {
    const response = (await getToAccountBalance({
      id: transaction?.recipientAccount.id,
      currencyId: transaction?.currencyId as string,
    })) as { data: { data: { edges: { node: { value: number } }[] } } };

    if (response.data) {
      setToAccountBalance(response.data.data.edges[0].node.value);
    }
  }, [transaction]);

  useEffect(() => {
    if (transaction) {
      getFromAccountBalanceAction();
      getToAccountBalanceAction();
    }
  }, [transaction]);

  return (
    <NostroGeneralContent
      isLoading={
        isLoading || isFetching || toBalanceIsLoading || toBalanceIsFetching
      }
      transactionInfo={transaction}
      fromAccountBalance={fromAccountBalance}
      toAccountBalance={toAccountBalance}
      currenciesList={currenciesList}
      paymentsTypes={paymentTypes?.map((item) => ({
        name: item.name,
        value: item.paymentType,
      }))}
    />
  );
};

export default ProblemNostroGeneralContentHOC;
